// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalqa.b2clogin.com/tfp/mncportalqa.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  production: false,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://sdoh.portalqa.mynexuscare.com',
  apiUrl: 'https://api-sdoh.portalqa.mynexuscare.com/api',
  hhApiUrl: 'https://api-homehealth.portalqa.mynexuscare.com/api',
  platformUrl: `https://api-platform.portalqa.mynexuscare.com/api`,
  registryUrl: `https://api-platform.portalqa.mynexuscare.com/api/app-registry`,
  wccLibraryUrl: 'https://mncregqa.blob.core.windows.net/documentlibrary/hh/wcc/library',
  notificationsGatewayUrl: 'https://api-notification-gateway.portalqa.mynexuscare.com',
  specialtyProgramsUrl: 'https://api-specialtyprograms-gateway.portalqa.mynexuscare.com/api',
  authConfig: {
    config: {
      auth: {
        clientId: '386a6be3-ed0d-4bcc-ac0a-178b0d194913',
        postLogoutRedirectUri: 'https://sdoh.portalqa.mynexuscare.com',
        redirectUri: 'https://sdoh.portalqa.mynexuscare.com',
        knownAuthorities: ['mncportalqa.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`
      }
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalqa.onmicrosoft.com/api/api.Write',
        'https://mncportalqa.onmicrosoft.com/api/api.Read',
        'https://mncportalqa.onmicrosoft.com/api/user_impersonation'
      ],
      protectedResourceMap: [
        [
          'https://api-sdoh.portalqa.mynexuscare.com/*',
          [
            'https://mncportalqa.onmicrosoft.com/api/api.Write',
            'https://mncportalqa.onmicrosoft.com/api/api.Read',
            'https://mncportalqa.onmicrosoft.com/api/user_impersonation'
          ]
        ],
        [
          'https://api-homehealth.portalqa.mynexuscare.com/*',
          [
            'https://mncportalqa.onmicrosoft.com/api/api.Write',
            'https://mncportalqa.onmicrosoft.com/api/api.Read',
            'https://mncportalqa.onmicrosoft.com/api/user_impersonation'
          ]
        ],
        [
          'https://api-platform.portalqa.mynexuscare.com/*',
          [
            'https://mncportalqa.onmicrosoft.com/api/api.Write',
            'https://mncportalqa.onmicrosoft.com/api/api.Read',
            'https://mncportalqa.onmicrosoft.com/api/user_impersonation'
          ]
        ]
      ]
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
